(() => {
  const selector = '[name="add"], [data-add-to-cart], [data-pf-type="ProductATC"], [data-pf-type="ProductATC2"]';
  const init = () => {
    document.querySelectorAll('#MainContent form[action]').forEach(form => {
      if (!/\/cart\/add\/?$/.test(new URL(form.action, window.location.href).pathname) || form.dataset.sbBuyNowReady) return;
      const buttons = Array.from(form.querySelectorAll(selector));
      if (!buttons.length) return;
      form.dataset.sbBuyNowReady = 'true';
      let redirect = form.querySelector('input[name="return_to"]');
      if (!redirect) {
        redirect = document.createElement('input');
        redirect.type = 'hidden';
        redirect.name = 'return_to';
        form.appendChild(redirect);
      }
      redirect.value = '/checkout';
      buttons.forEach(button => {
        button.dataset.checkout = 'checkout';
        if (!button.disabled && button.getAttribute('aria-disabled') !== 'true') {
          const label = button.querySelector('[data-add-to-cart-text]') || button;
          label.textContent = window.theme?.strings?.buyNow || 'Buy now';
        }
      });
      form.addEventListener('click', event => {
        const button = event.target.closest(selector);
        if (!button || button.form !== form) return;
        const variant = form.querySelector('input[name="id"]:checked, select[name="id"], input[name="id"][type="hidden"]');
        if (variant && !variant.disabled && /^\d+$/.test(variant.value)) event.stopImmediatePropagation();
      }, {capture: true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
